// extracted by mini-css-extract-plugin
module.exports = {"dot":"fK","department":"fL","departmentContent":"fM","departmentbiggerText":"fN","departmentText":"fO"};